import React from 'react';
import { t } from '../../services/i18nService';
import deliveringService from '../../services/DeliveringService';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';
import sessionReader from '../../store/readHelpers/SessionReader';
import styles from './options.scss';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';

class OptionsWithdraw extends React.PureComponent {
    actionHandler = () => {
        deliveringService.withdrawFromTest();
    };

    render() {
        const mainButtonText = t('options.withdrawButtonText');

        return (
            <div>
                <OptionsTopBar
                    title={t('options.withdraw')}
                    showOptionsButton
                    exitButtonProps={getA11yAttributesV2({ 'aria-label': t('options.closeOptionsMenu') })}
                    optionsButtonProps={getA11yAttributesV2({ 'aria-label': t('options.backToOptionsList') })}
                />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        mainButtonText={mainButtonText}
                        actionHandler={this.actionHandler}
                        requireInvigilatorPassword={sessionReader.testUsesInvigilatorPassword()}
                        {...getA11yAttributesV2({
                            confirmButtonA11y: { 'aria-label': t('options.withdrawButtonText') },
                            cancelButtonA11y: { 'aria-label': t('generic.cancel') },
                        })}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsWithdraw;
